import React from 'react';
import { Link } from 'react-router-dom';

import Rating from '@prisjakt/ui-rating';
import Currency from '@prisjakt/ui-currency';
import { ProductAlertFormData } from '../../types';

import * as S from './styles';

interface ProductAlertInfoProps {
  productAlertFormData: ProductAlertFormData;
}

const ProductAlertInfo = (props: ProductAlertInfoProps) => {
  const { productAlertFormData } = props;
  const product = productAlertFormData.product;

  return (
    <S.ProductAlertInfo>
      {product?.media.first && (
        <Link to={product.pathName}>
          <S.ProductInfoImage src={product.media.first} alt={product.name} />
        </Link>
      )}
      <S.ProductInfoName>
        <h2>
          {product?.pathName && (
            <Link to={product.pathName}>{product?.name}</Link>
          )}
          {!product?.pathName && <span>{product?.name}</span>}
        </h2>
        <Rating
          hide={product?.userReviewSummary.count === 0}
          count={product?.userReviewSummary.count}
          rate={product?.userReviewSummary.rating}
          showCounter
          showRate
        />
      </S.ProductInfoName>
      {!!product?.priceSummary.regular && (
        <S.ProductInfoPrice>
          <Currency price={product?.priceSummary.regular} />
        </S.ProductInfoPrice>
      )}
    </S.ProductAlertInfo>
  );
};

export default ProductAlertInfo;
